import React, { useState } from 'react';
import styled from 'styled-components';
import ActionTracking from '../@resources/img/action-tracking.png';
import Energize from '../@resources/img/energize.png';
import Jira from '../@resources/img/jira.png';
import TeamCollaboration from '../@resources/img/team-collaboration.png';
import { Colors } from '../patterns/Colors';

const SPLASHES = [
    {
        key: 'team-collaboration',
        title: 'Make your team collaboration focused and fun',
        copy: 'Choose from 100+ expertly crafted, fully customisable, meeting templates.',
        img: TeamCollaboration,
    },
    {
        key: 'jira',
        title: 'Work with your Jira backlog on a visual board',
        copy: 'Pull issues into your session, collaborate as a team, and sync updates back to Jira automatically.',
        img: Jira,
    },
    {
        key: 'energize',
        title: 'Bring energy and shared moments into your sessions',
        copy: 'Use built-in interactive features to make remote and hybrid meetings more engaging and enjoyable.',
        img: Energize,
    },
    {
        key: 'action-tracking',
        title: 'Keep your team focused with Action Tracking',
        copy: 'Create and follow up on actions across sessions, with reminders, visibility, and review built into the workflow.',
        img: ActionTracking,
    },
];

export const SplashPane = () => {

    const [splash] = useState(() => SPLASHES[Math.floor(Math.random() * SPLASHES.length)]);

    return <Pane>
        <SplashHeading>{splash.title}</SplashHeading>
        <SplashImage src={splash.img} />
        <SplashCopy>{splash.copy}</SplashCopy>
    </Pane>;
};

const Pane = styled.div`
    display: none;

    @media (min-width: 640px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: ${Colors.primary};
        color: white;
        padding: 2.5rem;
    }
`;

const SplashHeading = styled.h2`
    font-size: 1.875rem;
    font-weight: 500;
    margin: 0;
    line-height: 1.2;
`;

const SplashImage = styled.img`
    margin: 0 -2.5rem;
    width: calc(100% + 5rem);
`;

const SplashCopy = styled.p`
    font-size: 0.875rem;
    margin: 0;
`;
